import React, { useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../css/home.css";
import Form2 from "../components/Form2";
import Banner from "../components/Banner";
function importAll(r) {
  return r
    .keys()
    .sort()
    .map((key) => ({
      src: r(key),
      name: key.replace("./", ""),
    }));
}
const gallery = importAll(
  require.context("../assets/people", false, /\.(png|jpe?g|webp)$/i)
);

export default function Home() {
  const stripRef = useRef(null);
  const [zoomedIndex, setZoomedIndex] = useState(null);

  const scrollStrip = (dir) => {
    const el = stripRef.current;
    if (!el) return;
    const oneCard = el.querySelector(".people-card")?.offsetWidth || 240;
    el.scrollBy({ left: dir * (oneCard + 16) * 2, behavior: "smooth" });
  };

  const toggleZoom = (idx) => {
    setZoomedIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <>
      {/* HERO */}
      <main className="home hero hero-part">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={7} className="text-start">
              <h1 className="hero-title mt-5 mb-5">
                <span className="hero-eyebrow">LYLE JOUBERT</span>
                <span className="hero-headline">FITNESS</span>
                <span className="hero-headline fs-2"> &</span>
                <span className="hero-headline">COACHING</span>
              </h1>
              <h2 className="subtitle mb-3">
                Certified personal trainer specialized in strength, fat loss,
                and tailored coaching.
              </h2>
              <p className="lead mb-5 text-light">
                Start your journey today — choose a workout plan or request
                personalized coaching to reach your goals faster.
              </p>
            </Col>
            <Col xs={12} md={5} className="hero-image d-none d-md-block" />
          </Row>
        </Container>
      </main>

      {/* GRAY BAND: About + People */}
      <section className="method-band">
        {/* ABOUT / METHOD */}
        <section className="about py-4 text-black">
          <Container>
            <Row>
              <Col xs={12} md={7} className="text-start">
                <h2 className="mb-3 mt-3">I’m Lyle </h2>
                <p className="lead">
                  I help busy professionals and recreational athletes get
                  stronger, leaner, and more mobile — without sacrificing life
                  outside the gym.
                </p>
                <p className="lead">My background as a professional rugby player in Italy’s Serie A (7 championships, 2017–2025) shapes the way I build resilient athletes and healthy lifestyles.</p>
                <h3 className="h4 mt-4 mb-2">My method</h3>
                <ul className="about-list">
                  <li>Simple periodization: balanced strength, hypertrophy, and conditioning.</li>
                  <li>Clear, measurable progressions — no “secrets” or gimmicks.</li>
                  <li>Coaching on technique and recovery: sleep, stress, and basic nutrition.</li>
                  <li>Programs that adapt to your calendar, not the other way around.</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        {/* PEOPLE I TRAIN */}
        <section className="people py-4">
          <Container>
            <h2 className="section-title mb-3">People I Train</h2>

            <div className="people-strip-outer">
              <button
                className="people-nav people-nav--prev"
                aria-label="Scroll left"
                onClick={() => scrollStrip(-1)}
              >
                ‹
              </button>

              <div className="people-strip" ref={stripRef} aria-label="Gallery strip">
                {gallery.map((img, i) => {
                  const isZoomed = zoomedIndex === i;
                  return (
                    <figure className={`people-card ${isZoomed ? "is-zoomed" : ""}`} key={img.name || i}>
                      <img
                        src={img.src}
                        alt={(img.name || `person-${i + 1}`).replace(/\.(png|jpe?g|webp)$/i, "")}
                        className={isZoomed ? "zoomed" : ""}
                        onClick={() => toggleZoom(i)}
                        loading={i < 6 ? "eager" : "lazy"}
                        decoding="async"
                      />
                    </figure>
                  );
                })}
              </div>

              <button
                className="people-nav people-nav--next"
                aria-label="Scroll right"
                onClick={() => scrollStrip(1)}
              >
                ›
              </button>
            </div>
          </Container>
        </section>
      </section>

      {/* CONSULTATION SUB-HERO */}
      <section className="consult-hero py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <h2 className="consult-hero__title">
                <span className="consult-hero__eyebrow">Ready to get coached?</span>
                <span className="consult-hero__headline">Fill the form and request a call</span>
              </h2>
              <p className="consult-hero__copy">
                Tell me about your goals and schedule. I’ll get back to you to plan a free 15’ discovery call.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
<div id="separation">

</div>
      {/* FORM con anchor per il link del bottone finale */}
      <section id="contact-form">
        <Form2 />
      </section>

      {/* BIOGRAPHY SECTION */}
      <section className="bio-section">
        <div className="bio-overlay">
          <div className="bio-content container">
            <div className="bio-text">
              <h3 className="bio-title">About Lyle</h3>
              <p>
                Lyle Joubert is a certified strength & conditioning coach with over 10 years of experience
                training athletes and professionals. Former rugby player, he specializes in building strength,
                improving mobility, and guiding clients through tailored programs that fit real lives.
              </p>
              <p>
                His approach is simple: structured training, measurable progress, and sustainable habits.
                Whether you want to get stronger, leaner, or improve overall fitness, Lyle’s coaching blends
                expertise and motivation to help you perform your best.
              </p>
            </div>
            <div className="bio-photo">
              <img src={require("../assets/coach-rugby/1.jpeg")} alt="Coach Lyle Joubert" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINALE (ultimo elemento prima del footer) */}
      <section className="final-cta">
        <Container>
          {/* Uso .bio-text per riutilizzare esattamente lo stile dei paragrafi di About Lyle */}
          <div className="bio-text text-center">
            <p>
              Interested in a tailored path to your goals? Start with a{" "}
              <strong>free trial call</strong> — online or in person in{" "}
              <strong>Pesaro (Via Toscana)</strong>. Tell me about your current level,
              schedule and objectives: I’ll propose the most effective approach for you.
            </p>
            <p>
              Fill out the contact form and I’ll get back to you shortly to schedule your free call
              and outline the next steps toward your results.
            </p>

            <a href="#contact-form" className="lastbtn btn btn-gradient btn-lg mt-2">
              Request your Free Call
            </a>
          </div>
        </Container>
      </section>
          <Banner/>
    </>
  );
}
